import { useCallback } from 'react'
import logger from 'logger'
import { track } from 'analytics'
import { processError } from 'helpers'
import type { ApplePayInstance, ApplePayPaymentAuthorizedEvent } from '@recurly/recurly-js'


type UseApplePaySubmitProps = {
  applePayRef: React.RefObject<ApplePayInstance>
  submit: PaymentModule.PaymentFlowOnSubmit
  payStep: PaymentModule.PayStep
}
const useApplePaySubmit = ({ applePayRef, submit, payStep }: UseApplePaySubmitProps) => {
  const processToken = useCallback((token: { id: string }) => {
    logger.info('[ApplePay] start process token')
    const tokenGetter: PaymentModule.TokenGetter = () => Promise.resolve({
      tokenId: token.id,
    })

    return submit({ tokenGetter, paymentMethod: 'APPLE_PAY' })
  }, [ submit ])

  const submitApplePay = useCallback(() => {
    track('Express checkout click', {
      paymentMethod: 'APPLE_PAY',
      payStep,
    })

    const applePay = applePayRef.current

    if (applePay) {
      try {
        // this fires when tokes is available
        applePay.once('token', (token) => {
          if (!token) {
            logger.error('[ApplePay] token is null')
            return
          }

          logger.info(token, '[ApplePay] token')
          void processToken(token)
        })

        applePay.once('error', (error) => {
          logger.info(`[ApplePay] window was closed with error`, error)
          processError(error)
        })

        applePay.once('cancel', () => {
          logger.info(`[ApplePay] window was closed`)
        })

        applePay.begin()
      }
      catch (error) {
        processError(error)
      }
    }
  }, [ payStep, applePayRef, processToken ])

  return { submitApplePay }
}

export default useApplePaySubmit
